import { render } from "./Writing.vue?vue&type=template&id=d4554482"
import script from "./Writing.vue?vue&type=script&lang=js"
export * from "./Writing.vue?vue&type=script&lang=js"

import "./Writing.vue?vue&type=style&index=0&id=d4554482&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__